<template>
  <div>
    <div class="card text-bg-warning" style="width: 100%">
      <div class="card-body">
        <h5 class="card-title text-center fs-1">About Us</h5>
        <p class="card-text fs-5 ms-2 me-2 mb-2">
          SelfyBooks is a website where people who love to read Self-Help Books
          can share All of the things about the book that the people have read.
          This website provides all the betterness of sharing Quotes, Thoughts,
          Comments, and anything about Self-Help Books.
        </p>
      </div>
    </div>
    <div class="card text-bg-success mt-3" style="width: 100%">
      <div class="card-body">
        <h5 class="card-title text-center fs-1">
          Who Is The Maker Of The Website?
        </h5>
        <div class="text-center">
          <img
            src="../assets/foto.jpeg"
            class="rounded"
            alt="..."
            style="width: 15%"
          />
        </div>
        <h5 class="card-title text-center">Raihan Hafizh</h5>
        <h5 class="card-title text-center">English Education Program</h5>
        <h5 class="card-title text-center">Institut Pendidikan Indonesia</h5>
        <p class="card-text fs-5 ms-2 me-2 mb-2">
          A student of English Education Program at Indonesia Institute of
          Education known as Institut Pendidikan Indonesia who joined into
          Alterra Academy Kampus Merdeka Batch 2 spesifically at the program of
          Understanding Vue Js Front-End Engineer.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutItem",
};
</script>
